var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BMessage',{staticClass:"mfa-warning",attrs:{"type":"is-warning","closable":false}},[_vm._v(" "+_vm._s(_vm.$t('authentication.warning.requires-mfa'))+" "),_c('RouterLink',{attrs:{"to":`/settings/profile`}},[_vm._v(" "+_vm._s(_vm.$t('navigation.settings.my-profile'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }